/* eslint react/prop-types: 0 */
import React from 'react';
import { toCurrency, toLocale } from '../../../helpers/numberHelper';
import './tooltip.style.css';

export const COLOR_PALETTE = {
    black: '#000000',
    cyan: '#57E2CF',
    lightBlue: '#57AEE3',
    blue: '#5669E2',
    violet: '#8B56E2',
    purple: '#CF56E3',
    pink: '#E256AD',
    red: '#E45567',
    orange: '#E38955',
    yellow: '#E2CF56',
    lime: '#AEE357',
    green: '#68E357',
    paleGreen: '#56E289',
    seaGreen: '#009999',
};

export const COLORS_ARRAY = [
    COLOR_PALETTE.blue,
    COLOR_PALETTE.purple,
    COLOR_PALETTE.red,
    COLOR_PALETTE.yellow,
    COLOR_PALETTE.green,
    COLOR_PALETTE.cyan,
    COLOR_PALETTE.lightBlue,
    COLOR_PALETTE.violet,
    COLOR_PALETTE.pink,
    COLOR_PALETTE.orange,
    COLOR_PALETTE.lime,
    COLOR_PALETTE.paleGreen,
    COLOR_PALETTE.black,
];

// Return a color given the index of a segment in a chart
export function colorByIndex(index, colorScheme = COLORS_ARRAY) {
    return colorScheme[index % colorScheme.length];
}

export const tooltipContent = (props) => {
    if (!props.active) return null;

    const { payload, label } = props;
    return (
        <div className="tooltip">
            <div className="tooltip-header">{label}</div>
            <div className="tooltip-content">
                <div className="tooltip-content-section">
                    {payload.map(row => (
                        <p
                            key={row.name}
                            style={{ color: row.stroke }}
                            className="info"
                        >
                            {props.formatter(row.value, row.name, row)}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export const localeTooltipValueFormatter = (value, name) => (
    `${name}: ${toLocale(value)}`
);

export const currencyTooltipValueFormatter = (value, name) => (
    `${name}: ${toCurrency(value)}`
);

// Format an axis' tick by converting it with toLocale
export function numberTickFormatter(value) {
    return toLocale(value);
}

// Format an axis' tick by converting it with toCurrency
export function priceTickFormatter(value) {
    return toCurrency(value);
}
